/* eslint-disable react/require-default-props */
import React from 'react';
import { Box, HStack, Text } from '@chakra-ui/core';
import { IconType } from 'react-icons';
import colors from '../../../../../styles/colors';
import { InfoHint } from '../../../../common/Tooltip/Tooltip';

export interface CountChipProps {
  count: number;
  title: string;
  Icon: IconType;
  size?: string | number | undefined;
}

function CountChipComponent({ count, title, Icon, size = 20, ...props }: CountChipProps) {
  return (
    <InfoHint label={title} width="fit-content">
      <Box as="div" display="inline-block" {...props}>
        <HStack spacing={2}>
          <Icon fill={colors.gray[500]} size={size} />
          <Text color="gray.500" fontSize="xs">
            {count}
          </Text>
        </HStack>
      </Box>
    </InfoHint>
  );
}

export const CountChip = React.memo(CountChipComponent);
